import Keycloak from "keycloak-js";
import { KEYCLOAK } from "../env";

//Configurações do token realm tstsaude para o client tstsaude-frontend
// Access Token Lifespan Expires in 5 Minutes - tempo de vida do token (lifespan)
// Client Session Idle Expires in 1 Days - tempo maximo sem atividade até expirar o token
// Client Session Max Expires in 1 Days - tempo maximo até expirar a sessão

const checkLoginIframeInterval = 60;  // Verifica validade do token a cada 60 segundos
const tokenMinValidity = 210;          // Renova o token se a validade for menor que 210 segundos (3 minutos e meio)

const keycloak = await new Keycloak({
    realm: "tst-saude",
    url: KEYCLOAK,
    clientId: "tstsaude-frontend",
    enableLogging: true
  }
);

export function isUserInRole (role) {
  return (
    keycloak.tokenParsed &&
    keycloak.tokenParsed["realm_access"]["roles"].indexOf(role) > -1
  );
}

export function initKeycloak () {
  return keycloak.init({
    onLoad: 'login-required',
    checkLoginIframe: true,
    checkLoginIframeInterval: checkLoginIframeInterval,
    tokenMinValidity: tokenMinValidity
  }).then((authenticated) => {
      setupAutomaticTokenRefresh(keycloak);
      if (!authenticated) {
        console.warn(`Não autenticado!`);
        login();
        return;
      }
      return;
    })
    .catch((err) => {
      console.log(err)
      throw err;
    });
}

function setupAutomaticTokenRefresh(keycloak) {
  setInterval(() => {
    if (keycloak.isTokenExpired(tokenMinValidity)) {
      keycloak.updateToken(tokenMinValidity)
      .then(refreshed => {
          console.log(refreshed)
          if (refreshed) {
            console.log('Token atualizado com sucesso');
          } 
        }).catch(error => {
          console.error('Falha ao atualizar Token', error);
        });
    } else {
      console.log('Token ainda é valido');
    }
  }, checkLoginIframeInterval * 1000);
}

export const login = keycloak.login;

export const logout = () => {
  const params = new URLSearchParams({
    'client_id': keycloak.clientId,
    'refresh_token': keycloak.refreshToken,
    'post_logout_redirect_uri': window.location.origin,
    'id_token_hint': keycloak.idToken
  });

  
  fetch(keycloak.createLogoutUrl(), {
    method: 'POST',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: params
  }).then(response => {
    window.location.href = '/';
    console.log('Logout successful', response);
  }).catch(error => {
    console.log('Logout failed', error);
  });
};


export const getToken = () => keycloak.token;
export const getTokenParsed = () => keycloak.tokenParsed;
export const getUsername = () => keycloak.tokenParsed && keycloak.tokenParsed.preferred_username.toUpperCase();
export const getUserEmail = () => keycloak.tokenParsed && keycloak.tokenParsed.email;
export const getName = () => keycloak.idTokenParsed && keycloak.idTokenParsed.name;
export const getCodigoUsuario = () => parseInt(getUsername().replace(/\D/g, ""));
export const getRoles = () => {
  if (!keycloak.tokenParsed) return [];

  const roles = [];
  if (keycloak.tokenParsed["realm_access"].hasOwnProperty('roles')) {
    for (const role of keycloak.tokenParsed.realm_access.roles) {
      roles.push(role);
    }
  }

  for (let client of Object.keys(keycloak.tokenParsed["resource_access"])) {
    if (keycloak.tokenParsed["resource_access"][client].hasOwnProperty('roles')) {
      for (const role of keycloak.tokenParsed["resource_access"][client].roles) {
        roles.push(role);
      }
    }
  }
  return roles;
}

export default keycloak;
